var _style, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMaskIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 519 519",
    style: {
      enableBackground: "new 0 0 519 519"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;stroke:#FFFFFF;stroke-width:50;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st1{fill:none;stroke:#FFFFFF;stroke-width:30;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st2{fill:none;stroke:#FFFFFF;stroke-width:30;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st3{fill:none;stroke:#FFFFFF;stroke-width:50;stroke-linecap:round;stroke-miterlimit:10;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M187.5,101.8c47-22,94.5-36,143.1-36c52.8,0,110.3,14,160,36c1.8,28.3,4.9,112.9-40.5,197 c-22.6,41.9-72.7,99.5-110.6,99.5 M187.5,101.8c-1.8,28.3-4.9,112.9,40.5,197c22.6,41.9,73.5,99.5,111.4,99.5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M240,203.2c0-15.5,37-20.2,53.5-20.2c9.6,0,23.9,3.4,23.9,20.2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M436.3,203.2c0-15.5-37-20.2-53.5-20.2c-9.6,0-23.9,3.4-23.9,20.2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M280.5,274.2c1.7,18.8,39.3,37.4,58,37.6c20.3,0.1,59.1-18.8,59.1-37"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M256.5,435.7 M26.5,253.2c24.3-28.5,50.9-52.8,81.1-70.3c6.7-3.9,13.6-7.5,20.6-10.7 M26.5,253.2 c8.8,23.4,37.2,92.4,104.3,143.4c33.4,25.4,95.3,53.1,125.7,39.2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M98,274.2c4.8,10.8,30.3,12,40.6,7.2c5.9-2.8,27.1-11.3,30.4-19.2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaskIcon);
export default __webpack_public_path__ + "static/media/maskIcon.23016dea2a24e62541b9c67fe480dade.svg";
export { ForwardRef as ReactComponent };